import styled from 'styled-components';
import { up } from 'styled-breakpoints';


const ButtonGroup = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: ${props => props.halfWidth ? '0 auto' : 'none'};


    ${up('md')} {
        font-size: 1.1em;
    }

    ${up('lg')} {
        width: ${props => props.halfWidth ? '60%' : '100%'};
        button {
            width: 42%;
        }
    }

    button {
        width: 48%;
    }

    a {
      width: 48%;
    }
`;

export default ButtonGroup;
